import React, { useLayoutEffect } from 'react';

import PropTypes from 'prop-types';

import Immutable from 'immutable';

import { connect } from 'react-redux';

import { MANUAL_VOUCHER_PAYMENT_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';

import Loader from '../../../common/Loader';

import NoDataResource from '../../../common/resource/NoDataResource';
import ManualVoucherPaymentResource from './resource/ManualVoucherPaymentBasicInformationResource';
import {
  clearManualVoucherPayment,
  getManualVoucherPayment,
} from '../../../../actions/corporate/ManualVoucherPayment';
import ManualVoucherPaymentToolbar from './ManualVoucherPaymentToolbar';

export const ManualVoucherPayment = ({
  breadcrumbs,
  dispatchGetManualVoucherPayment,
  dispatchClearManualVoucherPayment,
  match: {
    params: { id: manualVoucherPaymentId },
  },
  loading,
  manualVoucherPayment,
}) => {
  useLayoutEffect(() => {
    dispatchGetManualVoucherPayment({ manualVoucherPaymentId });

    return () => dispatchClearManualVoucherPayment();
  }, []);

  let content;
  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (manualVoucherPayment.isEmpty()) {
    content = <NoDataResource returnPage={MANUAL_VOUCHER_PAYMENT_PATH} />;
  } else {
    const manualVoucherPaymentJson = manualVoucherPayment.toJS();

    content = <ManualVoucherPaymentResource {...manualVoucherPaymentJson} />;

    toolbar = (
      <ManualVoucherPaymentToolbar
        manualVoucherPaymentId={manualVoucherPaymentJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Pago de Comprobante Manual"
      content={content}
      toolbar={toolbar}
    />
  );
};

ManualVoucherPayment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearManualVoucherPayment: PropTypes.func.isRequired,
  dispatchGetManualVoucherPayment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  manualVoucherPayment: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ManualVoucherPayment.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetManualVoucherPayment: getManualVoucherPayment,
  dispatchClearManualVoucherPayment: clearManualVoucherPayment,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Pagos de Comprobantes Manuales',
      href: MANUAL_VOUCHER_PAYMENT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],

  manualVoucherPayment: CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'content',
  ]),

  loading: !CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualVoucherPayment);
